import React from 'react';
import styled from 'styled-components';
import { colors } from '../styles/utilities/settings';


const Chart = ({ width, percent, content }) => (
  <SChart percent={percent}>
    <svg width={width || '100%'} viewBox="0 0 100 50">
      <defs>
        <linearGradient id="grad1" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop
            offset="0%"
            style={{
              stopColor: colors.green,
              stopOpacity: 1,
            }}
          />
          <stop
            offset="29%"
            style={{
              stopColor: colors.yellow,
              stopOpacity: 1,
            }}
          />
          <stop
            offset="60%"
            style={{
              stopColor: colors.red,
              stopOpacity: 1,
            }}
          />
          <stop
            offset="100%"
            style={{
              stopColor: colors.red,
              stopOpacity: 1,
            }}
          />
        </linearGradient>
        <linearGradient id="grad2" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop
            offset="100%"
            style={{
              stopColor: colors.lightGray,
              stopOpacity: 1,
            }}
          />
        </linearGradient>
      </defs>
      <g fillOpacity="0" strokeWidth="10">
        <path className="bg" d="M5 50a45 45 0 1 1 90 0" stroke="url(#grad2)" />
        <path
          className="progress"
          d="M5 50a45 45 0 1 1 90 0"
          stroke="url(#grad1)"
          strokeDasharray="142"
          strokeDashoffset="142"
        />
      </g>
    </svg>
    <div className="labels">
      <p>0</p>
      <p>100</p>
    </div>
    <h4>
      {percent}
      {content && (
      <span dangerouslySetInnerHTML={{
        __html: content,
      }}
      />
      )}
    </h4>
  </SChart>
);

export default Chart;

export const SChart = styled.div`
  position: relative;

  .progress {
    stroke-dashoffset: ${({ percent }) => (180 - percent * 180 / 100)}%;
  }

  h4 {
    position: absolute;
    width: 100%;
    font-size: 45px;
    line-height: 1 !important;
    bottom: 20%;
    margin: 0 !important;

    span {
      line-height: 1 !important;
      display: block;
      font-size: 16px;
      font-weight: 100;
    }
  }

  .labels {
    display: flex;
    justify-content: space-between;
    position: relative;
    width: 100%;
  }
`;
